import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthService } from '../../../services/auth.service';
import { GoogleAnalyticsEventsService } from '../../../services/google-analytics-events.service';
import { IcortexAccountsPortalUrlService } from '../../../services/icortex-accounts-portal-url.service';
import { IcortexLocalizedPathService } from '../../../services/icortex-localized-path.service';
import { IcortexRefProtocolService } from '../../../services/icortex-ref-protocol.service';
import { wfImage as wfImageFn } from '../wf-static';

@Component({
  standalone: true,
  selector: 'app-wf-navbar',
  imports: [ RouterModule ],
  templateUrl: './wf-navbar.component.html'
})
export class WfNavbarComponent implements OnInit {

  readonly wfImage = wfImageFn;

  readonly logoSrc = wfImageFn( 'logo-icortex-2-2.svg' );

  /** Accounts portal URL for Log In (path /es/, /pt/, /ko/ or LOCALE_ID). */
  private readonly accountsLoginOrigin = inject( IcortexAccountsPortalUrlService ).getAccountsPortalOrigin();

  private readonly icortexRefProtocolService = inject( IcortexRefProtocolService );

  private readonly googleAnalyticsEventsService = inject( GoogleAnalyticsEventsService );

  private readonly authService = inject( AuthService );
  private readonly icortexLocalizedPathService = inject( IcortexLocalizedPathService );


  /**
   * @description Builds the Log In URL appending the stored refProtocol as a `protocol` query parameter when present.
   * @return Accounts portal URL ready for the Log In link.
   */
  get accountsLoginUrl(): string {

    return this.icortexRefProtocolService.appendRefProtocolQueryParam( this.accountsLoginOrigin );
  }


  sendGAEvent( category: string, action: string, label: string, value?: number ): void {

    this.googleAnalyticsEventsService.emitEvent( category, action, label, value );
  }

  ngOnInit(): void {

    this.authService.handleAuthentication();
  }

  protected localizedPath( path: string ): string {

    return this.icortexLocalizedPathService.getLocalizedPath( path );
  }

}
